import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        wrapper: {
            display: 'flex',
            width: '300px',
            marginTop: '-8px',
        },
        inputWrapper: {
            margin: 0,
        },
        inputsWrapper: {
            gap: theme.spacing(3),
        },
        dateSelectorContainer: {
            margin: 0,
        },
        dateSelectorLabel: {
            paddingTop: '0px !important',
        },
        dateSelectorHelperText: {
            display: 'none',
        },
    }
})

export default useStyles
